import {toast} from "react-toastify";
import {tellParentURLMessage} from "./utils";

export const notify = (id, type, message, preventClose, locatorClassName, popupObj) => {
    if (popupObj) {
        tellParentURLMessage({
            action: 'notify',
            severity: type,
            message: message
        }, popupObj.selectionUrl)
        // window.parent.postMessage({
        //     action: 'notify',
        //     severity: type,
        //     message: message
        // }, popupObj.selectionUrl);
    } else if (!toast.isActive(id)) {
        const options = {
            position: "bottom-right",
            autoClose: preventClose ? false : 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            bodyClassName: locatorClassName ? locatorClassName : '',
        };
        toast[type](message, options);
    }
};
